module.exports = __webpack_public_path__ + "static/media/ic-mentee-info-off.2d245b93.webp";